import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["actionMetadataConfig"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import AutomationBuilderCard from 'automation-ui-flow-core/canvas/AutomationBuilderCard';
import * as CanvasIdentifiers from 'automation-ui-flow-core/canvas/CanvasIdentifiers';
import { getActionIconAndColorForType } from 'automation-ui-action-features/utils/actionThemeUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const EmptyActionCard = _ref => {
  let {
      actionMetadataConfig
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  let actionTypeSpecificProps = {};
  if (actionMetadataConfig) {
    const {
      iconName,
      iconUrl,
      theme
    } = getActionIconAndColorForType({
      actionMetadataConfig
    });
    actionTypeSpecificProps = Object.assign({}, actionTypeSpecificProps, {
      headerIcon: iconName,
      headerImage: iconUrl,
      headerTitle: actionMetadataConfig.getActionLabel(undefined, undefined, undefined),
      titleUseTheme: theme
    });
  }
  return /*#__PURE__*/_jsx(AutomationBuilderCard, Object.assign({}, restProps, {
    content: /*#__PURE__*/_jsx("div", {
      className: CanvasIdentifiers.EMPTY_CONTENT_CARD,
      "data-test-id": "new-action",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "action-features.empty-action-card.configuring"
      })
    }),
    isHighlighted: false,
    isSelected: true
  }, actionTypeSpecificProps));
};
export default EmptyActionCard;